/**
 * Banner 1035 — BDU Programme Hero
 * Banner 1025's slide carousel with an h2 sub-heading and two CTAs: a transparent
 * "Apply Now" and a gradient-filled "Brochure". Slides carry their own
 * desktop/mobile background, title, sub-heading and colours; accreditation badges
 * are section level (`metadata_1`) and render on every slide that has a title.
 */

export const BANNER_1035_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Carousel slides",
    metadata_1: "Accreditation badges",
  },

  DEFAULT_ROW: {
    id: "1",
    image: "",
    alt_image: "Online MBA",
    mobile_image: "",
    mobile_alt_image: "Online MBA",
    title: "Online MBA",
    subtitle: "Master of Business Administration",
    title_color: "#FFFFFF",
    subtitle_color: "#FFFFFF",
    priority: 1,
    status: true,
  },

  DEFAULT_ROW_1: {
    id: "1",
    image: "",
    alt_image: "",
    priority: 1,
    status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "slide_frequency",
      label: "Slide interval (ms)",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "5000",
      required: true,
      defaultValue: 5000,
    },
    {
      fieldName: "hero_section_height",
      label: "Section height from 768px up (px) — below that it is fixed at 402px",
      value: 540,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "540",
      defaultValue: 540,
    },
    {
      fieldName: "gradient_color_1",
      label: "Overlay panel gradient — start (first slide, 768px and up)",
      value: "#13344F",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#13344F",
    },
    {
      fieldName: "gradient_color_2",
      label: "Overlay panel gradient — end (first slide, 768px and up)",
      value: "#77B6EB",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#77B6EB",
    },
    {
      fieldName: "background_color",
      label: "Overlay panel fill below 768px (first slide)",
      value: "#22405ADB",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#22405ADB",
    },
    {
      fieldName: "apply_now_show",
      label: "Show Apply Now button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "Apply Now — label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Apply Now",
      defaultValue: "Apply Now",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "Apply Now — is CTA (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of the CTA URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "apply_now_link",
      label: "Apply Now — URL (used when Is CTA is off)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/contact or https://…",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_color",
      label: "Apply Now — text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_border_color",
      label: "Apply Now — border colour (the button itself is transparent)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "download_brochure_show",
      label: "Show Brochure button",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "download_brochure_text",
      label: "Brochure — label",
      value: "Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Brochure",
      defaultValue: "Brochure",
    },
    {
      fieldName: "download_brochure_is_cta",
      label: "Brochure — is CTA (lead popup, then download)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = lead capture popup then download; off = open the URL directly",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "download_brochure_link",
      label: "Brochure — PDF URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://…/brochure.pdf",
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_3",
      label: "Brochure gradient — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "gradient_color_4",
      label: "Brochure gradient — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "cta_text_color",
      label: "Brochure — text & icon colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "horizontal_stripe_color",
      label: "Accreditation bar background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Slide background (desktop)",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Desktop background image",
      defaultValue: "",
    },
    {
      header: "Background alt (desktop)",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Slide background (mobile)",
      fieldName: "mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Mobile background image (optional — uses desktop if empty)",
      defaultValue: "",
    },
    {
      header: "Background alt (mobile)",
      fieldName: "mobile_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title (programme name)",
      fieldName: "title",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      rows: 2,
      placeholder:
        "Press Enter for a line break (applied from 768px up). Slide with no title renders image only (no overlay panel)",
      defaultValue: "",
    },
    {
      header: "Sub-heading (rendered at the title's size)",
      fieldName: "subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Master of Business Administration",
      defaultValue: "",
    },
    {
      header: "Title colour",
      fieldName: "title_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Sub-heading colour",
      fieldName: "subtitle_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [
    {
      header: "Badge image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload accreditation badge",
      defaultValue: "",
    },
    {
      header: "Badge alt",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
